module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/030-ea4fa27134118e9946643d1104c942e6.jpg";